import dayjs        from 'dayjs';
import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class MessageModel extends ApiModel {
  static get path() {
    return '/backend/messages/{?id}';
  }

  @computed
  get content(): string {
    return this.get('content');
  }

  @computed
  get createdById(): id {
    return this.get('createdBy.id');
  }

  @computed
  get createdAt(): string {
    return this.get('createdAt');
  }

  @computed
  get createdAtDate() {
    return dayjs(this.get('createdAt'));
  }

  @computed
  get createdByFirstName(): string {
    return this.get('createdByFirstName');
  }

  @computed
  get createdByLastName(): string {
    return this.get('createdByLastName');
  }

  @computed
  get createdByFullName(): string {
    return `${this.createdByFirstName} ${this.createdByLastName}`;
  }

  @computed
  get createdByStandRole(): string {
    return this.get('createdByStandRole');
  }

  @computed
  get createdByRoleIri(): string {
    return this.get('createdByRole.@id');
  }

  @computed
  get createdByRoleReference(): string {
    return this.get('createdByRole.reference');
  }
}
